module.exports = __webpack_public_path__ + "img/eos_ibc.wt.eos.27fd08b.png";